/* =====================================================================
   UUGI Education Program — listing page interactions
   Depends on jQuery + education-data.js (window.UUGI_EDU)
   ===================================================================== */

$(function () {

  var DATA = window.UUGI_EDU || { programs: [] };
  var programs = DATA.programs;

  /* ---------- small helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function splitDate(d) {
    // "12 Feb 2026" -> { day:'12', rest:'Feb 2026' }
    var parts = String(d).split(' ');
    return { day: parts[0] || '', rest: parts.slice(1).join(' ') };
  }
  var pinSvg = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1 C5 1 3 3 3 6 C3 10 8 15 8 15 C8 15 13 10 13 6 C13 3 11 1 8 1 Z M8 4 A2 2 0 1 1 8 8 A2 2 0 1 1 8 4 Z" stroke="currentColor" stroke-width="1" fill="none"/></svg>';
  var calSvg = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="2" y="3" width="12" height="11" rx="1" stroke="currentColor" stroke-width="1.2" fill="none"/><path d="M2 6 H14 M6 2 V4 M10 2 V4" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>';
  var usrSvg = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="6" r="2.5" stroke="currentColor" stroke-width="1.2" fill="none"/><path d="M3 14 C3 11 5 9 8 9 C11 9 13 11 13 14" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>';
  var arrowSvg = '<svg viewBox="0 0 16 16"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';


  /* ---------- Past programs (server-rendered) ---------- */
  // The past-program filter tabs (#eduFilters) and cards (#eduGrid) are now rendered
  // server-side from the Umbraco back office (see PastPrograms.cshtml) — tab labels and
  // counts come from the programs' distinct Program Types. The code that built them from
  // the static array has been removed; the filter behaviour below operates on that
  // server-rendered DOM. $filters is still resolved for the click handler.
  var upcoming = programs.filter(function (p) { return p.status === 'upcoming'; });
  var $filters = $('#eduFilters');


  /* ---------- Render: upcoming list ---------- */
  // var $up = $('#eduUpList');
  // upcoming.forEach(function (p) {
  //   var d = splitDate(p.date);
  //   var regClass = 'edu-reg--open', regText = p.regStatus || 'Open';
  //   var st = (p.regStatus || '').toLowerCase();
  //   if (st.indexOf('fast') >= 0) regClass = 'edu-reg--fast';
  //   else if (st.indexOf('soon') >= 0) regClass = 'edu-reg--soon';
  //   $up.append(
  //     '<a class="edu-up reveal" href="education-program-detail.html?id=' + encodeURIComponent(p.id) + '">' +
  //       '<div class="edu-up__date"><strong>' + d.day + '</strong><span>' + esc(d.rest) + '</span></div>' +
  //       '<div class="edu-up__body">' +
  //         '<p class="edu-up__loc">' + pinSvg + esc(p.typeLabel) + ' · ' + esc(p.college) + ' · ' + esc(p.city) + '</p>' +
  //         '<h3>' + esc(p.title || p.college) + '</h3>' +
  //         '<p class="edu-up__theme">' + esc(p.summary) + '</p>' +
  //       '</div>' +
  //       '<div class="edu-up__side">' +
  //         '<span class="edu-reg ' + regClass + '"><span class="edu-reg__dot"></span>' + esc(regText) + '</span>' +
  //         '<span class="edu-up__more">Learn More ' +
  //           '<svg viewBox="0 0 16 16"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
  //         '</span>' +
  //       '</div>' +
  //     '</a>'
  //   );
  // });


  // /* ---------- Render: partners marquee ---------- */
  // function crestHtml(p) {
  //   return '<span class="edu-crest">' +
  //     '<span class="edu-crest__mark">' + esc(p.crest) + '</span>' +
  //     '<span class="edu-crest__txt"><strong>' + esc(p.college) + '</strong><span>' + esc(p.city.split(',')[0]) + '</span></span>' +
  //   '</span>';
  // }
  // var crestsA = programs.map(crestHtml).join('');
  // // second row offset for variety
  // var rotated = programs.slice(4).concat(programs.slice(0, 4));
  // var crestsB = rotated.map(crestHtml).join('');
  // // duplicate each track for seamless -50% loop
  // $('#eduMarqueeA').html('<div class="edu-marquee__track">' + crestsA + crestsA + '</div>');
  // $('#eduMarqueeB').html('<div class="edu-marquee__track">' + crestsB + crestsB + '</div>');


  /* ---------- Scroll reveal (after render) ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $('.reveal').addClass('is-visible');
  }
  // Safety net: if IntersectionObserver never fires in this context
  // (e.g. offscreen render / PDF export), reveal everything so content
  // is never permanently invisible. No-op when scroll-reveal is working.
  setTimeout(function () {
    if (!document.querySelector('.reveal.is-visible')) {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('is-visible');
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    }
  }, 1600);


  /* ---------- Filter behaviour ---------- */
  $filters.on('click', '.edu-tab', function () {
    var $btn = $(this);
    var f = $btn.attr('data-filter');
    $('.edu-tab').removeClass('is-active').attr('aria-pressed', 'false');
    $btn.addClass('is-active').attr('aria-pressed', 'true');

    var visible = 0;
    $('#eduGrid .edu-card').each(function (i) {
      var $c = $(this);
      var match = (f === 'all' || $c.attr('data-type') === f);
      if (match) {
        visible++;
        $c.removeClass('is-hidden');
        $c.css({ opacity: 0, transform: 'translateY(14px) scale(0.98)' });
        setTimeout(function () {
          $c.css({ opacity: 1, transform: 'translateY(0) scale(1)', transition: 'opacity .5s, transform .5s' });
        }, i * 45);
      } else {
        $c.css({ opacity: 0, transform: 'translateY(8px) scale(0.96)' });
        setTimeout(function () { $c.addClass('is-hidden'); }, 320);
      }
    });
    $('#eduEmpty').prop('hidden', visible !== 0);
  });


  /* ---------- Counters ---------- */
  function animateCounter($el, target, dur, suffix) {
    dur = dur || 1800; suffix = suffix || '';
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      $el.text(Math.floor(eased * target).toLocaleString('en-IN') + suffix);
      if (t < 1) requestAnimationFrame(tick);
      else $el.text(target.toLocaleString('en-IN') + suffix);
    }
    requestAnimationFrame(tick);
  }
  var countersRun = false;
  function runCounters() {
    if (countersRun) return;
    countersRun = true;
    $('.edu-hero__stat strong[data-count]').each(function () {
      var $el = $(this);
      animateCounter($el, parseInt($el.attr('data-count'), 10) || 0, 1800, $el.attr('data-suffix') || '');
    });
  }
  setTimeout(runCounters, 650);


  /* ---------- Loader ---------- */
  $(window).on('load', function () { setTimeout(function () { $('#loader').addClass('is-gone'); }, 350); });
  setTimeout(function () { $('#loader').addClass('is-gone'); }, 2000);


  /* ---------- Navbar scroll state ---------- */
  var $nav = $('#nav');
  function onScroll() { if ($(window).scrollTop() > 30) $nav.addClass('is-scrolled'); else $nav.removeClass('is-scrolled'); }
  $(window).on('scroll', onScroll); onScroll();


  /* ---------- Smooth anchor scroll ---------- */
  $('a[href^="#"]').on('click', function (e) {
    var t = $(this).attr('href');
    if (t.length < 2) return;
    var $tgt = $(t);
    if (!$tgt.length) return;
    e.preventDefault();
    $('html, body').animate({ scrollTop: $tgt.offset().top - 70 }, 700, 'swing');
  });


  /* ---------- Hero parallax ---------- */
  $(window).on('mousemove', function (e) {
    var x = e.clientX / window.innerWidth - 0.5;
    var y = e.clientY / window.innerHeight - 0.5;
    $('.edu-hero__chakra--lg').css('transform', 'translate(' + (x * 16) + 'px,' + (y * 16) + 'px) rotate(' + (window.scrollY * 0.02) + 'deg)');
    $('.edu-hero__lotus').css('transform', 'translate(calc(-50% + ' + (x * -12) + 'px), calc(-50% + ' + (y * -12) + 'px))');
  });


  /* ---------- Mobile nav drawer: see js/nav.js ---------- */


  /* ---------- Form feedback ---------- */
  $('#eduForm').on('submit', function (e) {
    e.preventDefault();
    var $lbl = $(this).find('button[type="submit"] .jbtn__label');
    var orig = $lbl.text();
    $lbl.text('Sent ✓ — धन्यवाद');
    var form = this;
    setTimeout(function () { $lbl.text(orig); form.reset(); }, 2600);
  });

  $('.footer__news').on('submit', function (e) {
    e.preventDefault();
    var $btn = $(this).find('button');
    var orig = $btn.text();
    $btn.text('Thanks ✓');
    $(this).find('input').val('');
    setTimeout(function () { $btn.text(orig); }, 2400);
  });

});


/* =====================================================================
   Past Programs — type filter (server-rendered by PastPrograms.cshtml)
   Moved here from EducationProgram.cshtml inline @section Scripts.
   Operates on #pastFilters / #pastGrid / #pastEmpty; no-op on pages
   without the past-programs section.
   ===================================================================== */
$(function () {
  var $filters = $('#pastFilters');
  if (!$filters.length) return;

  /* Reveal fallback (in case the global observer misses these) */
  $('#pastGrid .reveal, #pastFilters.reveal, .edu-past__head.reveal').addClass('is-visible');

  /* Type filter */
  $filters.on('click', '.edu-tab', function () {
    var f = $(this).attr('data-filter');
    $filters.find('.edu-tab').removeClass('is-active').attr('aria-pressed', 'false');
    $(this).addClass('is-active').attr('aria-pressed', 'true');

    var visible = 0;
    $('#pastGrid .edu-card').each(function (i) {
      var $c = $(this);
      var match = (f === 'all' || $c.attr('data-type') === f);
      if (match) {
        visible++;
        $c.removeClass('is-hidden');
        $c.css({ opacity: 0, transform: 'translateY(14px) scale(0.98)' });
        setTimeout(function () {
          $c.css({ opacity: 1, transform: 'translateY(0) scale(1)', transition: 'opacity .5s, transform .5s' });
        }, i * 45);
      } else {
        $c.css({ opacity: 0, transform: 'translateY(8px) scale(0.96)' });
        setTimeout(function () { $c.addClass('is-hidden'); }, 320);
      }
    });
    // Hide the empty-state instantly when there are matches; when there are none,
    // wait for the outgoing cards to finish hiding (matches the 320ms above) before
    // revealing it, so cards and the empty text are never shown at the same time.
    var $pastEmpty = $('#pastEmpty');
    if (visible === 0) {
      setTimeout(function () { $pastEmpty.prop('hidden', false); }, 330);
    } else {
      $pastEmpty.prop('hidden', true);
    }
  });
});
